<template>
  <div class="text-center container-fluid container-lg" v-if="contactItem">
    
    <div v-if="action && action == 'confirm' && !contactItem.confirmed"
      class="alert alert-info my-3">
      <h4 class="alert-heading">Welcome {{ contactItem.name }} {{ contactItem.surname }}!</h4>
      <hr>
      <p>
        Please, <strong>check your personal data</strong> and update it if needed.
        <span v-if="!contactItem.image"><br>
        You can also upload an image for your profile</span>
      </p>
    </div>
  
    <div v-if="!editphoto" id="profile" class="row justify-content-center">
      <div class="col-auto" style="position: relative;">
        <div v-if="!offlineMode" class="edit">
          <button type="button" class="btn" @click="editPhoto"><i class="fa fa-camera"></i></button>
        </div>

        <ContactImage :contactItem="contactItem" :publicPath="publicPath" />
      </div>
    </div>
    
    <div v-if="editphoto" class="text-start">
    
      <div class="my-3">
        <label for="image" class="form-label">Upload a photo</label>
        <input type="file" class="form-control" id="image" @change="uploadImage">
      </div>
      
      <div class="text-center mb-3">
        <button type="button" class="btn btn-coesia me-2" @click="savePhoto">
          <i class="fa fa-save"></i>
          Save image
        </button>
        <button type="button" class="btn btn-secondary ms-2" @click="clearEditPhoto">
          <i class="fa fa-times"></i>
          Cancel
        </button>
      </div>
      
    </div>
    
    <h2>{{ contactItem.name }} {{ contactItem.surname }}</h2>
    
    <div v-if="!edit" id="profile-info">
      <ContactInfo :contactItem="contactItem" />
      
      <button v-if="!offlineMode" type="button" class="btn btn-secondary" @click="editInfo">
        <i class="fa fa-edit me-2"></i> 
        Edit info
      </button>
      
    </div>
    
    <div v-if="edit" class="text-start">
    
      <h3 class="profile-info text-center">
        <span v-if="contactItem.company">{{ contactItem.company }}</span> 
        <span v-if="contactItem.country">({{ contactItem.country }})</span>
      </h3>
      
      <hr>

      <form id="profileForm">
        <div class="mb-3">
          <label for="telephone" class="form-label">Telephone <br class="d-lg-none"><small>(format: +xx xxxxxxxxxx or +xx xxx xxxxxxx)</small></label>
          <input type="tel" class="form-control" id="telephone" v-model="input.telephone" placeholder="Your telephone" title="+xx xxxxxxxxxx or +xx xxx xxxxxxx" pattern="[\+][0-9]{1,3}[\s]{1}[0-9]{3}[\s]{0,1}[0-9]{5,9}">
        </div>

        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" v-model="input.email" placeholder="Your email" disabled>
        </div>

        <div class="mb-3">
          <label for="unit" class="form-label">Unit</label>
          <input type="text" class="form-control" id="unit" v-model="input.unit" placeholder="Your Unit">
        </div>

        <div class="mb-4">
          <label for="role" class="form-label">Role</label>
          <input type="text" class="form-control" id="role" v-model="input.role" placeholder="Your role">
        </div>

        <div class="text-center my-4">
          <button type="button" class="btn btn-coesia me-2" @click="saveInfo">
            <i class="fa fa-save"></i>
            Save info
          </button>
          <button type="button" class="btn btn-secondary ms-2" @click="clearEditInfo">
            <i class="fa fa-times"></i>
            Cancel
          </button>
        </div>
      </form>
      
    </div>
    
    <div  v-if="deferredPrompt"  class="my-4">
      <button 
        type="button"
        class="btn btn-coesia"
        v-if="!testing"
        @click="downloadApp"
        ref="addBtn"
        >
          <i class="fa fa-download me-2"></i> 
          Add App to home screen
        </button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import ContactImage from '../contacts/ContactImage';
import ContactInfo from '../contacts/ContactInfo';

export default {
  name: 'ProfilePage',
  props: ['action'],
  computed: {
    ...mapGetters([
      'user',
      'offlineMode',
      'testing',
      'apiPath'
    ]),
    contactItem () {
      if (this.user) {
        return this.$store.getters.contactItemFromId(Number(this.user.id));
      } else {
        let userName = this.$store.getters.getUserName;
        let userEmail = this.$store.getters.getUserEmail;
        return this.$store.getters.contactItemFromLogin(userName, userEmail);
      }
    },
  },
  created() {
    if (this.action && this.action == 'confirm') this.editInfo();
  },
  data() {
    return {
      edit: (this.action && this.action == 'confirm') ? true : false,
      editphoto: false,
      image: "",
      thumb: "",
      publicPath: process.env.BASE_URL,
      deferredPrompt:null,
      input: {
        role: "",
        unit: "",
        telephone: "",
        email: ""
      }
    };
  },
  mounted(){
    this.captureEvent()
  },
  methods: {
    captureEvent(){
      console.log('in captureEvent')
       window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e
      })
    },
    downloadApp(){
       // Show the prompt
      this.deferredPrompt.prompt()
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          // Add analyticcs event
          this.$gtag.event('add_to_home_screen')
        }
        this.deferredPrompt = null
      })
    },
    editInfo() {
      this.edit = true;
      this.input = {
        role: this.contactItem.role,
        unit: this.contactItem.unit,
        telephone: this.contactItem.telephone,
        email: this.contactItem.email
      };
      //console.log(this.contactItem);
    },
    clearEditInfo() {
      this.edit = false;
    },
    editPhoto() {
      this.editphoto = true;
    },
    clearEditPhoto() {
      this.editphoto = false;
    },
    saveInfo() {
      let myform = document.getElementById('profileForm')
      let valid = myform.checkValidity()
      if (!valid) {
        myform.reportValidity()
        return false
      }
      document.getElementById("email").removeAttribute("disabled")
      let contactItem = {
        id: this.user.id,
        role: this.input.role,
        unit: this.input.unit,
        telephone: this.input.telephone,
        email: this.input.email,
        confirmed: 1
      }
      console.log(contactItem);
      // => funzione salvataggio info
      this.$store.dispatch('saveProfileInfo', contactItem);
      this.edit = false;
      this.contactItem.confirmed = true
      document.getElementById("email").setAttribute("disabled", "disabled")
      if (this.action && this.action == 'confirm') {
        this.$router.push('/events')
      }
    },
    uploadImage (e) {
      let img = e.target.files[0]
      let fd= new FormData()
      fd.append('image', img)
      fd.append('tbl', 'users')
      fd.append('field', 'image')
      fd.append('id', this.user.id)
      fd.append('upload_path', 'images/profiles/')
      axios.post(this.apiPath +'admin/ajax/fileupload/', fd)
        .then(resp => {
           this.image = resp.data.location,
           this.thumb = resp.data.thumb
        })
    },
    savePhoto() {
      let contactItem = {
        id: this.user.id,
        image: this.image,
        thumb: this.thumb
      }
      //console.log(contactItem);
      // => funzione salvataggio foto
      this.$store.dispatch('saveProfileImage', contactItem);
      this.editphoto = false;
    }
  },
  components: {
    ContactImage,
    ContactInfo
  }
}
</script>

<style>
</style>

<style scoped>
#profile,
#profile-info { 
  position: relative; 
}
.edit {
  width: 42px;
  height: 42px;
  display: block;
  position: absolute;
  top: 1rem;
  right: -2rem;
}
#profile-info .edit {
  top: 0;
}
.edit button {
  padding: 0;
}
.edit .fa {
  font-size: 1.5em;
  color: #DA052C;
}
</style>